<template>
  <div class="vipAnalyze" @scroll="screenFiexd()" ref="vipAnalyze">
    <div>
      <screen :class="isFiexd ? 'fiexdScreen' : ''"></screen>
      <vipOverview></vipOverview>
      <vipElevator></vipElevator>
      <vipTendency></vipTendency>
      <vipProportion></vipProportion>
      <vipContribute></vipContribute>
      <vipComparison></vipComparison>
    </div>
  </div>
</template>

<script>
import screen from "./screen";
import vipOverview from "./vipOverview";
import vipElevator from "./vipElevator";
import vipTendency from "./vipTendency";
import vipProportion from "./vipProportion";
import vipContribute from "./vipContribute";
import vipComparison from "./vipComparison";
export default {
  components: {
    screen,
    vipOverview,
    vipElevator,
    vipTendency,
    vipProportion,
    vipContribute,
    vipComparison
  },
  data() {
    return {
      isFiexd: false
    };
  },
  methods: {
    screenFiexd() {
      // console.log(this.$refs.vipAnalyze.scrollTop)
      if (this.$refs.vipAnalyze.scrollTop > 20) {
        this.isFiexd = true;
      } else {
        this.isFiexd = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.vipAnalyze {
  height: 100%;
  padding: 15px;
  background: #f7f8fa;
  overflow-x: hidden;
  position: relative;

  .fiexdScreen {
    position: fixed;
    top: 60px;
    width: 100%;
    z-index: 2;
  }
}
</style>
